import script from "./NoticeView.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticeView.vue?vue&type=script&setup=true&lang=js"

import "./NoticeView.vue?vue&type=style&index=0&id=46c07235&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46c07235"]])

export default __exports__